import { jsonProperty, Serializable } from "ts-serializable";

class Alternativa extends Serializable{

    @jsonProperty(String, null)
    alternativaId: string | null = null;

    @jsonProperty(Number, null)
    ordem: number | null = 0;

    @jsonProperty(String, null)
    texto: string | null = null;

}  

export default Alternativa;